import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { CardType } from '../../schema/card';

interface CardTypeFromInputProps {
  required?: boolean;
  value?: number | null;
  onChange?: (value: number | null) => void;
  canSelectAll?: boolean;
}

const CardTypeFromInput: React.FC<CardTypeFromInputProps> = ({
  required,
  value,
  onChange,
  canSelectAll
}: CardTypeFromInputProps) => {
  const [cardTypeList, setCardTypeList] = useState<CardType[]>([]);
  useEffect(() => {
    api.get<CardType[]>(`/card_type?has_wpm=true&has_ost=true`).then((res) => {
      const { data } = res;
      setCardTypeList(data);
    });
  }, []);

  return (
    <FormControl fullWidth>
      <InputLabel>{`ประเภทบัตร${required ? ' *' : ''}`}</InputLabel>
      <Select
        label={`ประเภทบัตร${required ? ' *' : ''}`}
        variant="outlined"
        onChange={(e) => {
          if (onChange) {
            const parsed = parseInt(e.target.value);
            if (isNaN(parsed)) {
              onChange(null);
              return;
            }
            onChange(parsed);
          }
        }}
        value={value != null ? `${value}` : ''}
        autoComplete="off"
        required={required}
      >
        {canSelectAll ? <MenuItem value="">ทั้งหมด</MenuItem> : null}
        {cardTypeList.map((data, index) => (
          <MenuItem key={index} value={`${data.id}`}>
            {data.type_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CardTypeFromInput;
